import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    confirmationModalOpen: false,
    invoice: null,
}


export default handleActions({
    [type.SHOW_CONFIRMATION_MODAL]: (state, action) => {
        const { invoice } = action.payload
        return {
            ...state,
            confirmationModalOpen: true,
            invoice,
        }
    },
    [type.CLOSE_CONFIRMATION_MODAL]: (state, action) => {
        return {
            ...state,
            confirmationModalOpen: false,
            invoice: null,
        }
    },
    [type.CREATE_CORRECTION_SUCCESS]: (state, action) => {
        return {
            ...state,
            confirmationModalOpen: false,
            invoice: null,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/invoice/state/display/reducer.js